import { render } from "./Footer.vue?vue&type=template&id=76b753e3&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=76b753e3&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b753e3"]])

export default __exports__